import { memo } from "react";
import { AnimatePresence, motion } from "framer-motion";

import {
  selectChipVisible,
  useScratchpadChipStore,
} from "@/features/tutor/store/useScratchpadChipStore";

const SIZE = 40;

// Collapsing the width alone would still leave the row's 8px gap behind, so the
// margin closes with it and the field slides rather than jumps.
const COLLAPSED = { opacity: 0, scale: 0.7, width: 0, marginRight: -8 };
const EXPANDED = { opacity: 1, scale: 1, width: SIZE, marginRight: 0 };

const ScratchpadChip = () => {
  const visible = useScratchpadChipStore(selectChipVisible);
  const thumbnail = useScratchpadChipStore((s) => s.thumbnail);

  return (
    <AnimatePresence initial={false}>
      {visible && (
        <motion.div
          role="img"
          aria-label="Your scratchpad work will be sent with this message"
          title="Your scratchpad work will be sent with this message"
          initial={COLLAPSED}
          animate={EXPANDED}
          exit={COLLAPSED}
          transition={{ duration: 0.24, ease: [0.22, 1, 0.36, 1] }}
          style={{ height: SIZE, originX: 0 }}
          className="shrink-0 overflow-hidden rounded-xl border-[3px] border-[#1C6E4A] bg-[#E8F5EF]"
        >
          {thumbnail ? (
            <img
              src={thumbnail}
              alt=""
              draggable={false}
              style={{ width: SIZE, height: SIZE }}
              className="max-w-none object-cover"
            />
          ) : (
            <div
              style={{ width: SIZE, height: SIZE }}
              className="scratchpad-paper"
            />
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default memo(ScratchpadChip);
